import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import type { RootState, AppDispatch } from './store';
import { useEffect, useState } from 'react';
import { SCREENSIZE_BREAKPOINT } from '@/constants';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export function useWindowSize() {
  const [screenSize, setScreenSize] = useState(typeof window !== 'undefined' ? window.innerWidth : 0);
  let throttling = false;
  let delay = 500;

  function handleThrottleResize() {
    if (!throttling) {
      throttling = true;

      // Throttle delay
      setTimeout(() => {
        // Update the screenSize state when the window is resized
        if (typeof window !== 'undefined') {
          setScreenSize(window.innerWidth);
        }
        throttling = false;
      }, delay);
    };
  };

  useEffect(() => {
    window.addEventListener('resize', handleThrottleResize);

    return () => {
      window.removeEventListener('resize', handleThrottleResize);
    };
  }, []);

  return screenSize > SCREENSIZE_BREAKPOINT;
}
